<template>
  <div>
        <div class="layui-fluid">   
            <div class="layui-card">
                <div class="layui-form layui-card-header layuiadmin-card-header-auto">
                    <div class="layui-form-item"> 
                        <div class="layui-inline">
                            政区名称
                        </div>
                        <div class="layui-inline">
                            <input class="layui-input"  autocomplete="off"  placeholder="请输入政区名称" v-model="t_zq.queryObject['C_ZQNAME:2']">
                        </div>
                        <div class="layui-inline">
                            政区代码
                        </div>
                        <div class="layui-inline">
                            <input class="layui-input"  autocomplete="off"  placeholder="请输入政区代码" v-model="t_zq.queryObject['C_ZQCODE:2']">
                        </div>
                       <div class="layui-inline">
                            <button class="layui-btn layuiadmin-btn-list" @click="$refs.t_zq.search()" title="查询">查询</button>
                            <button class="layui-btn" @click="$refs.t_zq.reset()" title="重置">重置</button>
                        </div>
                    </div>
                </div>
                <div class="layui-card-body">
                    <div style="padding-bottom: 10px;">
                        <button class="layui-btn layuiadmin-btn-role" 
                            @click="$refs.zqForm.open('添加根节点');
                            $refs.zqForm.setDefaultValue('JB',1).setDefaultValue('L_PARID', -1).setDefaultValue('PARENT_ZQ', null);
                            $refs.zqForm.setEditRow();">
                            添加
                        </button>
                    </div>
                    <div class="layui-table-body layui-table-main">
                        <layui-tabletree 
                            ref="t_zq" 
                            :expand-level = "2"
                            table-name="FL_SYS_ZQSJZD" 
                            show-field="C_ZQNAME"
                            treeid = "L_ID"
                            treepid = "L_PARID"
                            jb-field="L_ZQJB"
                            :once-condition="{'L_ZQJB:1': '1,2'}"
                            :page-size="15" 
                            :page-range="6" 
                            :page-options="[15, 25, 50, 100]"
                            @tabletree-event-addchild="addchild($event.data)"
                            @tabletree-event-treeedit="treeEdit($event.data)"
                            @tabletree-event-treedel="treeDel($event.data)"
                            height="full-308">
                            <div>
                                <div field="C_ZQNAME" title="政区名称" align="center"></div>
                                <div field="C_ZQCODE" title="政区代码" align="center"></div>
                                <div field="C_ZQSHORTNAME" title="政区简称" align="center"></div>
                                <div field="L_JB" title="级别" align="center" width="80"></div>
                                <div field="_opt" width="250" align="center" toolbar title="操作">
                                    <script type="text/html">
                                        <a class="layui-btn layui-btn-primary layui-btn-xs" lay-event="addchild">新增下级</a>
                                        <a class="layui-btn layui-btn-xs"  lay-event="treeedit">编辑</a>
                                        <a class="layui-btn layui-btn-danger layui-btn-xs" lay-event="treedel">删除</a>
                                    </script>
                                </div>
                            </div> 
                        </layui-tabletree>
                    </div>
                </div>
            </div>
        </div>
        <layui-form ref="zqForm" :after-save = "treeAfterSave">
                <template slot-scope="{scope}">
                    <div class="layui-form"  style="padding: 20px 30px 0 0;">
                         <div class="layui-form-item" v-if="scope.editRow.PARENT_ZQ">
                            <label class="layui-form-label">上级政区：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.PARENT_ZQ"  autocomplete="off" class="layui-input" disabled="disabled">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"> <span class="x-red">*</span>政区名称：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.C_ZQNAME"  autocomplete="off" class="layui-input" name="C_ZQNAME">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"><span class="x-red">*</span>政区代码：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.C_ZQCODE"  autocomplete="off" class="layui-input" name="C_ZQCODE">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"> 政区缩写：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.C_ZQSHORTNAME"  autocomplete="off" class="layui-input" name="C_ZQSHORTNAME">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label class="layui-form-label"> <span class="x-red">*</span>级别：</label>
                            <div class="layui-input-inline">
                                <input type="text" v-model="scope.editRow.L_ZQJB"  autocomplete="off" class="layui-input" name="L_ZQJB" disabled="disabled">
                            </div>
                        </div>
                        <div class="layui-form-item">
                            <label for="L_repass" class="layui-form-label"> </label>
                            <button class="layui-btn" @click="$refs.zqForm.callableSave($refs.t_zq)">保存</button>
                            <button class="layui-btn" @click="$refs.zqForm.close()">关闭</button>
                        </div>
                    </div>
                </template>
            </layui-form>
    </div>
</template>

<script>
export default {
  name: 'Auth',
  data () {
    return {
       t_zq : {
            queryObject: {}
        },
    }
  },
  mounted() {
       this.t_zq = this.$refs.t_zq;
  },
  methods: {
      treeAfterSave(row, isNew) {
          var t_zq = this.$refs.t_zq;
          var zqForm = this.$refs.zqForm;
          var treeObjData = t_zq.getTableTreeObj().getTableTreeData();
          zqForm.close();
          if(row[t_zq.jbField] == 1) {
              //根节点
              if (isNew) {
                 // 新增
                 t_zq.data.push(row);
                 treeObjData.push(row);
              } else {
                 // 编辑
                for(var i = 0 ; i < t_zq.data.length ; i++) {
                    var item =  t_zq.data[i];
                    if(item[t_zq.treeid] == row[t_zq.treeid]) {
                        t_zq.data[i] = row;
                        treeObjData[i] = row;
                        break;
                    }
                }
              }
              
          } else {
            // 处理非根节点
                var parent = [];
                t_zq.findNodeById(row[t_zq.treepid], t_zq.data, parent);
                var parent = parent[0];
                if(! parent.treeList )  parent.treeList  = [];
                if(isNew) {
                    // 新增
                    parent.treeList.push(row);
                } else {
                    // 编辑
                    for(var i = 0 ; i < parent.treeList.length ; i++) {
                        var item = parent.treeList[i];
                        if(item[t_zq.treeid] == row[t_zq.treeid]) {
                            parent.treeList[i] = row;
                            break;
                        }
                    }
                }
             
              row._p = true;
          }
           t_zq.getTableTreeObj().refresh();
      },
      addchild(row) {
          var t_zq = this.$refs.t_zq;
          this.$refs.zqForm.open('添加下级节点');
          var parentJb = row[t_zq.jbField];
          this.$refs.zqForm.setDefaultValue('JB', Number(parentJb) + 1);
          this.$refs.zqForm.setDefaultValue('PARENT_ZQ', row.C_ZQNAME);
          this.$refs.zqForm.setDefaultValue('L_PARID', row.L_ID);
          this.$refs.zqForm.setEditRow();
      },
      treeEdit(row) {
           this.$refs.zqForm.open('编辑当前节点');
           this.$refs.zqForm.setEditRow(row);
      },
      treeDel(row) {
        var t_zq = this.$refs.t_zq;
        var p2 = {};
        var pid = row[t_zq.treeid];
        p2[t_zq.treepid] = pid;
        this.api.queryList(t_zq.tableName, {p2: p2,  p9: t_zq.selectFields, p10: t_zq.sort}).then(response => {
            var result = response.result;
            if(result.length == 0){
                this.layer.openConfirm('<span style="color:red">确定要删除该节点吗?</span>', ()=> {
                    this.api.delRows(t_zq.tableName, { p5: [row]}).then(response => {
                        t_zq.getTableTreeObj().delTreeNode(pid);
                        this.layer.openSuccess('删除成功!');
                    });
                });
            } else {
                this.layer.openAlert('该节点还有子节点，不能删除！', false);
            }
        });
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ywpt/zq/Zq.vue